import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { injectReducer } from "store/reducers";
import SubjectViewStudentProgressReport from "./routes/SubjectViewStudentProgressReport";
const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
const customUrlValidationFunction = ({ path }) => {
  // Check if the string is in Base64 format
  return base64Regex.test(path);
};
export default store => ({
  // path: ":subjectStudentProgressReportId",
  path: ":subjectViewVirtualId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-progressreport" */ "./components"),
        import(
          /* webpackChunkName: "course-progressreport" */ "ProgressReport/modules/ProgressReportModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "progressReport",
          reducer,
        });
        return withDynamicUrlValidation({
          component,
          urlValidationType: "customValidation",
          customUrlValidationFunction,
        });
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SubjectViewStudentProgressReport(store)],
});
